<template>
  <div align="center" class="home mt-2">
    <h4 style="margin-top: 50px">
      Seleccione el integrador con el que desea operar
    </h4>
    <div class="col-sm-12 mb-2">
      <div class="form-group col-md-4">
        <label for="integrador_select">Integrador</label>
        
        <div v-if="isLoading" class="my-4 text-center">
          <div class="spinner-border text-primary" role="status" style="width: 2.5rem; height: 2.5rem;">
            <span class="sr-only">Cargando...</span>
          </div>
          <div class="mt-2 text-muted font-weight-bold">
            Cargando lista de integradores...
          </div>
        </div>

        <select
          v-else
          class="form-control form-control-lg"
          v-model="integradorSel"
          name="integrador"
          aria-label="Integrador"
          id="integrador_select"
          @change="
            setIntegrador(integradorSel);
            redirect();
          "
        >
          <option :value="null">Seleccione Integrador</option>
          <template v-if="integradoresList && integradoresList.length">
            <option
              v-for="integrador in integradoresList"
              v-bind:key="integrador.id_integrador"
              v-bind:value="integrador.id_integrador"
            >
              {{ integrador.integrador }}
            </option>
          </template>
        </select>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from "vuex";
import { getDefaultRouteForUser, getUserFromToken } from "../../router";

export default {
  name: "selectIntegrador",
  data() {
    return {
      success: null,
      error: null,
      integradorSel: null,
    };
  },

  created() {
    const user = this.user || getUserFromToken();
    if (user && user.rol !== "admin" && user.integradores && user.integradores.length === 0) {
      this.$store.commit("setError", "El usuario no posee ningún integrador asignado", { root: true });
      this.$store.dispatch("auth/sendLogoutRequest").finally(() => {
        this.$router.push("/login").catch(() => {});
      });
      return;
    }
    let integrador = localStorage.getItem("integrador");
    if (!integrador && user && user.integradores && user.integradores.length > 0) {
      integrador = user.integradores[0].id_integrador || user.integradores[0].id;
      this.setIntegrador(integrador);
    }
    if (integrador) {
      const target = getDefaultRouteForUser(user);
      this.$router.push(target).catch(() => {});
      return;
    }
    if (this.integradores && this.integradores.data && this.integradores.data.length > 0) {
      const first = this.integradores.data[0].id_integrador || this.integradores.data[0].id;
      this.setIntegrador(first);
      this.redirect();
      return;
    }
    if (localStorage.getItem("authToken")) {
      this.fetchIntegradores(true);
    }
  },

  mounted() {
    if (localStorage.getItem("authToken") && (!this.integradores || !this.integradores.data || this.integradores.data.length === 0)) {
      this.fetchIntegradores(true);
    }
  },

  computed: {
    ...mapGetters("auth", ["user"]),
    ...mapGetters("integrador", ["integradores"]),
    integradoresList() {
      let list = [];
      if (this.integradores && this.integradores.data && this.integradores.data.length > 0) {
        list = [...this.integradores.data];
      } else if (this.user && this.user.integradores && Array.isArray(this.user.integradores)) {
        list = [...this.user.integradores];
      }
      return list.sort((a, b) =>
        String(a.integrador || "").localeCompare(String(b.integrador || ""), undefined, { sensitivity: "base" })
      );
    },
    isLoading() {
      const loadingState = Boolean(
        this.$store.state.loading ||
        (this.$store.state.integrador && this.$store.state.integrador.loadingIntegradores)
      );
      const hasData = Boolean(
        this.integradores &&
        this.integradores.data &&
        this.integradores.data.length > 0
      );
      return loadingState || !hasData;
    },
  },

  watch: {
    user: {
      immediate: true,
      handler(newUser) {
        if (newUser && (newUser.rol === "admin" || !localStorage.getItem("integrador"))) {
          this.fetchIntegradores(true);
        }
      },
    },
    integradores: {
      immediate: true,
      handler(newVal) {
        if (newVal && newVal.data) {
          if (newVal.data.length > 0) {
            const first = newVal.data[0].id_integrador || newVal.data[0].id;
            this.setIntegrador(first);
            this.redirect();
          } else if (newVal.data.length === 0 && (!this.user || this.user.rol !== "admin")) {
            this.$store.commit("setError", "El usuario no posee ningún integrador asignado", { root: true });
            this.$store.dispatch("auth/sendLogoutRequest").finally(() => {
              this.$router.push("/login").catch(() => {});
            });
          }
        }
      },
    },
  },

  methods: {
    ...mapMutations("integrador", ["setIntegrador"]),
    ...mapActions("integrador", ["fetchIntegradores"]),

    isAdmin() {
      return this.user && this.user.rol == "admin";
    },

    redirect() {
      const user = this.user || getUserFromToken();
      const target = getDefaultRouteForUser(user);
      this.$router.push(target).catch(() => {
        this.$router.push("/");
      });
    },
  },
};
</script>



<style scoped>
.tablesorter-header {
  position: relative;
  padding-right: 22px;
}

.tablesorter-header::before,
.tablesorter-header::after {
  position: absolute;
  right: 0.75em;
  font-family: "bootstrap-icons";
  opacity: 0.3;
  font-size: 0.8em;
}

.tablesorter-header::before {
  content: "\f235";
  top: calc(50% - 1.1em);
}

.tablesorter-header::after {
  content: "\f229";
  bottom: calc(50% - 1.1em);
}

.tablesorter-header.asc::before,
.tablesorter-header.desc::after {
  opacity: 1;
}
</style>
